import { Toaster as ToastHost } from '@/components/ui/toast';

/*
 * App toast host (spec §7.2). Mounts the Base UI toast primitive
 * (components/ui/toast). The app `notify` ergonomics helper lives in
 * `notify.ts` so this file exports only a component (react-refresh).
 */
export function Toaster() {
  return <ToastHost />;
}
